import { observer } from "mobx-react";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useRootStore } from "../../stores";
import { SwipeableDrawer, IconButton, Collapse, Checkbox } from "@mui/material";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import MenuIcon from "@mui/icons-material/Menu";
import CheckCircle from "@mui/icons-material/CheckCircle";
import RadioButtonUnchecked from "@mui/icons-material/RadioButtonUnchecked";
import "./styles.css";
import { Link } from "react-router-dom";
import { Colors, LOGO2 } from "../../assets";
import WebViewBridge from "../../webViewBridge";

const AppDrawer = () => {
  const { changeIsOpen, isOpen, setCurrentPage } =
    useRootStore().rootStore.drawerStore;
  const { place, language, setLanguage } = useRootStore().rootStore.placeStore;
  const { t, i18n } = useTranslation();
  const [languageCollapse, setLanguageCollapse] = useState(false);

  const getOrdersHistory = () => {
    setCurrentPage("ordersHistory");
    isOpen && changeIsOpen(false);
  };

  const getCurrentOrders = () => {
    setCurrentPage("main");
    isOpen && changeIsOpen(false);
  };

  const toggleDrawer = (open: boolean) => (event: any) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    changeIsOpen(open);
  };

  const changeLanguage = (lan: string) => {
    setLanguage(lan);
    if (lan === "arabic") i18n.changeLanguage("ar");
    if (lan === "english") i18n.changeLanguage("en");
    if (lan === "hebrew") i18n.changeLanguage("heb");
    WebViewBridge.getInstance().syncLanguage(i18n.language);
    if (i18n.language !== "en")
      document.getElementsByTagName("html")[0].setAttribute("dir", "rtl");
    else document.getElementsByTagName("html")[0].setAttribute("dir", "ltr");
  };

  useEffect(() => {
    if (window.innerWidth <= 590) toggleDrawer(false);
  });

  return (
    <React.Fragment>
      <div
        className="app-header-drawer"
        style={{
          left: i18n.language === "en" ? 0 : undefined,
          right: i18n.language !== "en" ? 0 : undefined,
        }}
      >
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={toggleDrawer(true)}
          edge="start"
          style={{ height: 50, marginLeft: 1, marginRight: 1 }}
        >
          <MenuIcon />
        </IconButton>
        <SwipeableDrawer
          anchor={i18n.language !== "en" ? "right" : "left"}
          open={isOpen}
          onClose={toggleDrawer(false)}
          onOpen={toggleDrawer(true)}
        >
          <div
            className="app-header-drawer-content"
            style={{
              fontFamily:
                i18n.language === "ar"
                  ? "'Cairo', sans-serif"
                  : "'Rubik', sans-serif",
            }}
          >
            <img src={LOGO2} alt="" className="app-header-drawer-logo" />
            {place !== undefined && place !== null && (
              <Link
                to={`/main`}
                onClick={() => getCurrentOrders()}
                className="app-header-drawer-link"
              >
                {t("Current orders")}
              </Link>
            )}
            <hr className="line" />
            {place !== undefined && place !== null && (
              <Link
                to={`/orders-history`}
                onClick={() => getOrdersHistory()}
                className="app-header-drawer-link"
              >
                {t("Orders history")}
              </Link>
            )}
            <hr className="line" />
            {place !== undefined && place !== null && (
              <Link
                to={`/place`}
                className="app-header-drawer-link"
                onClick={() => {
                  setCurrentPage("placePage");
                  changeIsOpen(false);
                }}
              >
                {t("Place page")}
              </Link>
            )}
            <hr className="line" />
            {place !== undefined && place !== null && (
              <Link
                to={`/place/budget`}
                className="app-header-drawer-link"
                onClick={() => {
                  setCurrentPage("budgetPage");
                  changeIsOpen(false);
                }}
              >
                {t("Budget")}
              </Link>
            )}
            <hr className="line" />
            {place !== undefined &&
              place !== null &&
              WebViewBridge.getInstance().isReactNative() && (
                <>
                  <button
                    type="button"
                    className="app-header-drawer-link"
                    onClick={() => {
                      WebViewBridge.getInstance().openPrinterSettings();
                      changeIsOpen(false);
                    }}
                  >
                    {t("Printer")}
                  </button>
                  <hr className="line" />
                </>
              )}
            <div className="collapsable-row">
              <div
                onClick={() => setLanguageCollapse((prev) => !prev)}
                className="collapsable-row-title"
              >
                <p>{t("Language")}</p>
                {languageCollapse ? <ExpandLess /> : <ExpandMore />}
              </div>
              <Collapse
                className="collapsable-row-content"
                in={languageCollapse}
                timeout="auto"
                unmountOnExit
              >
                <div
                  className="collapsable-row-item"
                  onClick={() => changeLanguage("hebrew")}
                >
                  <Checkbox
                    icon={
                      <RadioButtonUnchecked
                        className="UncheckedCircle"
                        style={{ color: Colors.GREEN }}
                      />
                    }
                    checkedIcon={<CheckCircle className="CheckCircle" />}
                    style={{
                      height: 20,
                      width: 20,
                    }}
                    checked={language === "hebrew"}
                  />
                  <p>{"עברית"}</p>
                </div>
                <hr className="line" />
                <div
                  className="collapsable-row-item"
                  onClick={() => changeLanguage("arabic")}
                >
                  <Checkbox
                    icon={
                      <RadioButtonUnchecked
                        className="UncheckedCircle"
                        style={{ color: Colors.GREEN }}
                      />
                    }
                    checkedIcon={<CheckCircle className="CheckCircle" />}
                    style={{
                      height: 20,
                      width: 20,
                    }}
                    checked={language === "arabic"}
                  />
                  <p>{"العربية"}</p>
                </div>
                <hr className="line" />
                <div
                  className="collapsable-row-item"
                  onClick={() => changeLanguage("english")}
                >
                  <Checkbox
                    icon={
                      <RadioButtonUnchecked
                        className="UncheckedCircle"
                        style={{ color: Colors.GREEN }}
                      />
                    }
                    checkedIcon={<CheckCircle className="CheckCircle" />}
                    style={{
                      height: 20,
                      width: 20,
                    }}
                    checked={language === "english"}
                  />
                  <p>{"English"}</p>
                </div>
                <hr className="line" />
              </Collapse>
            </div>
          </div>
        </SwipeableDrawer>
      </div>
    </React.Fragment>
  );
};

export default observer(AppDrawer);
